<template>
  <div class="bp-sheet">
    <a
      href="#main"
      class="bp-skip"
    >Skip to content</a>
    <div
      class="bp-zones"
      aria-hidden="true"
    >
      <span
        v-for="zone in zones"
        :key="zone"
      >{{ zone }}</span>
    </div>
    <BlueprintHeader />
    <div
      class="bp-grid bp-grid--minor"
      aria-hidden="true"
    />
    <div
      class="bp-grid bp-grid--major"
      aria-hidden="true"
    />
    <div
      class="bp-cross"
      aria-hidden="true"
    >
      <span class="bp-cross__x" />
      <span class="bp-cross__y" />
    </div>
    <div
      class="bp-leader"
      aria-hidden="true"
    >
      <div class="bp-leader__line" />
      <div class="bp-leader__head" />
      <div class="bp-leader__ticks" />
    </div>
    <main id="main">
      <slot />
    </main>
    <BlueprintFooter />
    <p
      class="bp-readout"
      aria-hidden="true"
    />
  </div>
</template>

<script setup lang="ts">
const zones = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H']

const { data: siteMetadata } = await useAsyncData('site-metadata', () => {
  return queryCollection('site').first()
})

// Get the current request URL for canonical/OG URLs
const requestUrl = useRequestURL()

useHead(() => {
  if (!siteMetadata.value) {
    return {
      htmlAttrs: { lang: 'en' }
    }
  }

  const metadata = siteMetadata.value
  const currentUrl = requestUrl.href
  const imageUrl = `${requestUrl.origin}${metadata.ogImage || '/img/blog-author.jpg'}`

  return {
    title: metadata.title,
    htmlAttrs: {
      lang: 'en'
    },
    link: [
      { rel: 'canonical', href: currentUrl }
    ],
    meta: [
      { name: 'description', content: metadata.description },
      { charset: 'utf-8' },
      { 'http-equiv': 'X-UA-Compatible', 'content': 'IE=edge,chrome=1' },
      { name: 'theme-color', content: metadata.themeColor || '#f4f5f2', media: '(prefers-color-scheme: light)' },
      { name: 'theme-color', content: '#0d141c', media: '(prefers-color-scheme: dark)' },
      // Open Graph
      { property: 'og:title', content: metadata.title },
      { property: 'og:description', content: metadata.description },
      { property: 'og:locale', content: metadata.ogLocale || 'en_US' },
      { property: 'og:url', content: currentUrl },
      { property: 'og:type', content: metadata.ogType || 'website' },
      { property: 'og:image', content: imageUrl },
      { property: 'og:image:width', content: metadata.ogImageWidth?.toString() || '400' },
      { property: 'og:image:height', content: metadata.ogImageHeight?.toString() || '400' },
      // Twitter Card
      { name: 'twitter:card', content: metadata.twitterCard || 'summary_large_image' },
      { name: 'twitter:site', content: metadata.twitterHandle || '@dbhagen' },
      { name: 'twitter:title', content: metadata.title },
      { name: 'twitter:description', content: metadata.description },
      { name: 'twitter:image', content: imageUrl }
    ]
  }
})
</script>
